import {Component, OnInit, TemplateRef} from '@angular/core';
import {ApiService} from '../../../core/http/api.service';
import {ToastrService} from 'ngx-toastr';
import {base64ToFile, ImageCroppedEvent} from 'ngx-image-cropper';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {UtilsService} from '../../../core/services/utils/utils.service';
import {DashboardService} from '../../dashboard.service';
import {Router} from '@angular/router';
import {Survey} from '../../banners/banners.component';
import { HttpClient, HttpEventType } from '@angular/common/http';

export interface Quote {
  createdAt: number;
  updatedAt: number;
  id: string;
  person_id: string;
  quoteBy: QuoteBy;
  type: string;
  famous_quote: string;
  status: string;
  byAdmin: boolean;
  addedBy: any;
}

export interface QuoteBy {
  name: string;
}

export interface Quote {
  person_id: string;
  type: string;
  famous_quote: string;
}

@Component({
    selector: 'app-banners',
    templateUrl: './add-survey.component.html',
    styleUrls: ['./add-survey.component.css'],
    standalone: false
})
export class AddSurveyComponent implements OnInit {

  modalRef: BsModalRef;
  croppedFile: any;
  aspectRatio = 1;
  uploading = false;
  progress = 0;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  html = `<span class=""><img src="assets/images/suffix-preview.png" width="500" alt=""></span>`;

  // Surveys
  polls: Survey[] = [];
  pollsCount = 0;
  survey = {
    questions: [{
      question: '',
      result_suffix: '',
      options: []
    }]
  };
  option: string;
  image: string;

  constructor(private api: ApiService,
              private toastr: ToastrService,
              private modalService: BsModalService,
              private httpClient: HttpClient,
              private utils: UtilsService,
              private router: Router,
              private dashApi: DashboardService) {
  }

  ngOnInit(): void {
  }

  createSurvey(): any {
    if (!this.survey.questions[0].question) {
      this.utils.toastError('Add question');
      return false;
    }
    if (this.survey.questions[0].options?.length < 2) {
      this.utils.toastError('Minimum two options required for a survey');
      return false;
    }
    this.api.addPoll(this.survey).subscribe(() => {
      this.utils.toastSuccess('Survey Created Successfully!');
      this.survey = {
        questions: [{
          question: '',
          result_suffix: '',
          options: []
        }],
      };
      this.router.navigate(['/surveys']);
    }, err => this.utils.resErr(err));
  }

  removeWordsAndSymbols(inputString): any {
    const pattern = /[?]|what|which|who|where/g;
    return (inputString || '').toLowerCase().replace(pattern, '').trim();
  }

  handleQuestionChange(value): any {
    this.survey.questions[0].result_suffix = this.removeWordsAndSymbols(value);
  }

  addOption(): any {
    this.survey.questions[0].options.push({option: this.option, image: this.image});
    this.option = '';
    this.image = '';
  }

  removeOption(idx): any {
    this.survey.questions[0].options.splice(idx, 1);
  }

  handleClickUpload(): void {
    const ele = document.getElementById('option_icon');
    if (!!ele) {
      ele.click();
    }
  }

  // IMAGE CROPPER
  fileChangeEvent(event: any, template: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(template);
    this.aspectRatio = 1;
    this.imageChangedEvent = event;
  }

  uploadImage(): any {
    this.uploading = true;
    const formData = new FormData();
    formData.append('file', this.croppedFile, this.croppedFile?.name || `upload-${Date.now()}.png`);
    const upload = this.httpClient.post<any>('file-upload', formData, {
      reportProgress: true,
      observe: 'events'
    });
    upload.subscribe(
      (res: any) => {
        if (res.type === HttpEventType.UploadProgress) {
          this.progress = Math.round((res.loaded / res.total) * 100);
        } else if (res.type === HttpEventType.Response) {
          this.uploading = false;
          this.image = res.body.response.url;
          this.progress = 0;
        }
      },
      (err) => {
        this.uploading = false;
        this.utils.resErr(err);
      }
    );
  }

  imageCropped(event: ImageCroppedEvent): void {
    this.croppedFile = new File([base64ToFile(event.base64)], `${Date.now()}.png`);
  }

  loadImageFailed(): void {
    this.utils.toastError('Image Load failed!');
  }

}
